<template>
  <div class="offcanvas offcanvas-full d-flex flex-column" id="preview-canvas">
    <!--end::Header-->
    <!--begin::Content-->
    <div class="offcanvas-content px-4
    h-100 d-flex flex-column align-content-center justify-content-center">
      <div class="close-modal"
           @click="close">
        <div class="dashed-border"/>
        <img src="@/assets/images/icons/Icon_cancel.svg" alt="">
      </div>
      <p class="modal-title">
        {{mediaTitle}}
      </p>
      <div class="video-player" v-if="type === 'video'">
        <vue-plyr ref="plyr">
          <video
            class="w-100 h-100"
            :poster="require('@/assets/images/background/Bg_Video_Player.jpg')"
            :src="mediaUrl"
            type="video/mp4" controls ></video>
        </vue-plyr>
      </div>
      <img v-if="type === 'image'"
           @contextmenu.prevent
           class="preview-image"
           v-lazy="mediaUrl" alt="preview"/>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
export default {
  name: 'PreviewCanvas',
  props: {
    type: {
      type: String,
      default: 'image',
    },
    mediaUrl: {
      type: String,
      default: null,
    },
    mediaTitle: {
      type: String,
      default: null,
    },
    mediaDescription: {
      type: String,
      default: null,
    },
  },
  methods: {
    close() {
      if (document.getElementById('preview-canvas').classList.contains('offcanvas-on')) {
        if (this.$refs.plyr != null) {
          this.$refs.plyr.player.stop();
        }
        this.$emit('close', { src: 'preview' });
      }
    },
  },
};
</script>
